import React, { useEffect, useState } from "react";
// import Footer from '../components/footer';
import styled from "styled-components";
import { Link } from '@reach/router';
import { useMoralis } from 'react-moralis';
import coverImagePlaceHolder from '../../../../src/assets/cover-image-placeholder.jpeg'
import BuyNFTContainer from '../../commons/NFT/BuyNFTContainer'
import { getSliceLongTxt } from '../../../helpers/formatters'
import UserIdenticon from "../../../components/commons/Identicon";
import { useWeb3React } from '@web3-react/core';
import Select from 'react-select'
import { toast } from 'react-toastify'

const Outer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
`;

const customStyles = {
  option: (base, state) => ({
    ...base,
    background: "#212428",
    color: "#fff",
    borderRadius: state.isFocused ? "0" : 0,
    "&:hover": {
      background: "#16181b",
    }
  }),
  menu: base => ({
    ...base,
    background: "#212428 !important",
    borderRadius: 0,
    marginTop: 0
  }),
  menuList: base => ({
    ...base,
    padding: 0
  }),
  control: (base, state) => ({
    ...base,
    padding: 2
  })
};


const ViewCollections = function ({ walletAddress, collectionId }) {

  const { Moralis, isInitialized } = useMoralis()
  const [collectionData, setCollectionData] = useState([])
  const [nftData, setNFTData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [coverImage, setCoverImage] = useState('')
  const [isLoadingProfile, setIsLoadingProfile] = useState(false)
  const [collectionName, setCollectionName] = useState('')
  const [profileData, setProfileData] = useState({})
  const [nftAttributes, setNftAttributes] = useState(null)
  const { account } = useWeb3React()
  const [selectedCollectionStatus, setSelectedCollectionStatus] = useState('')
  const [isCollectionUpdating, setIsCollectionUpdating] = useState(false)
  const [isAllowToEdit, setIsAllowToEdit] = useState(false)
  const [isAdmin, setIsAdmin] = useState(false)

  const nftStatus = [
    { value: 'active', label: 'Active' },
    { value: 'unpublish', label: 'Unpublish' },
  ]

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    const adminAddressLowerCase = []
    const adminAddress = process.env.REACT_APP_ADMIN_ADRS.split(',')

    if (adminAddress && adminAddress.length > 0) {
      adminAddress.forEach(address => {
        adminAddressLowerCase.push(address.toLowerCase())
      })
    }

    if (account) {
      const currentUserAddress = account.toLowerCase()
      const result = adminAddressLowerCase.includes(currentUserAddress)
      if (result) {
        setIsAdmin(true)
      } else {
        setIsAdmin(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account])


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {

    if (collectionData) {
      const attributes = collectionData[0]?.attributes || null
      if (attributes) {
        const createdBy = attributes.createdBy
        if (account === createdBy) {
          setIsAllowToEdit(true)
        }
      }
    }

    if (isAdmin) {
      setIsAllowToEdit(true)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, isAdmin, collectionData])

  const handleCollectionStatusChange = (selectedStatus) => {
    setSelectedCollectionStatus(selectedStatus.value)
  }

  const handleCollectionStatusUpdate = async () => {

    try {
      setIsCollectionUpdating(true)
      const Collections = Moralis.Object.extend("Collections")
      const query = new Moralis.Query(Collections)
      query.equalTo('objectId', collectionId)
      const result = await query.find()

      if (result && result.length > 0) {
        const collection = result[0]
        collection.set('status', selectedCollectionStatus)
        await collection.save()
      }
      setIsCollectionUpdating(false)

      toast.dark('Collection status has been updated', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      toast.dark('Something went wrong while updating the collection status', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.error("ERROR: something went wrong while updating collection status", error)
      setIsCollectionUpdating(false)
    }
  }


  useEffect(() => {
    if (collectionData) {
      const attributes = collectionData[0]?.attributes || null
      if (attributes) {
        setSelectedCollectionStatus(attributes.status || '')
      }

    }
  }, [collectionData])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {

    if (isInitialized) {
      try {
        setIsLoading(true)
        const Collections = Moralis.Object.extend("Collections")
        const query = new Moralis.Query(Collections)
        query.equalTo('objectId', collectionId)
        const result = await query.find()

        setCollectionData(result)
        setCollectionName(result[0].attributes.name)
        setNFTData(JSON.parse(result[0].attributes.selectedNFT) || [])
        getCoverImage(result)

      } catch (error) {
        setIsLoading(false)
        console.error('MORALIS ERROR : error while fetching marketplace data', error)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    setNftAttributes(collectionData[0] ? collectionData[0].attributes : null)
  }, [collectionData])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    try {
      setIsLoadingProfile(true)
      if (isInitialized && nftAttributes) {
        const params = { walletAddress: nftAttributes?.createdBy || null };
        const profileDataResponse = await Moralis.Cloud.run("getCreatorDetailsByAddress", params);
        setProfileData(profileDataResponse)
      }
      setIsLoadingProfile(false)
    } catch (error) {
      setProfileData({})
      setIsLoadingProfile(false)
      console.error("MORALIS : error while fetching profile data ", error)

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, nftAttributes])

  const getUsername = (moralisAttributes) => {

    if (moralisAttributes) {
      if ("username" in moralisAttributes && moralisAttributes.username !== "") {
        return getSliceLongTxt(moralisAttributes.username, 40)
      } else {
        return ''
      }
    } else {
      return ''
    }
  }

  const getCoverImage = (result) => {
    const moralisAttributes = result[0].attributes
    if (moralisAttributes) {
      if ("coverImageCID" in moralisAttributes && moralisAttributes.coverImageCID != null) {
        const collectionCoverImage = `https://hodl4gold.mypinata.cloud/ipfs/${moralisAttributes.coverImageCID}`
        setCoverImage(<img className="collection-cover-image" src={collectionCoverImage} alt="" />)
      } else {
        setCoverImage(<img className="collection-cover-image" src={coverImagePlaceHolder} alt="" />)
      }
    } else {
      setCoverImage(<img className="collection-cover-image" src={coverImagePlaceHolder} alt="" />)
    }
  };

  const getUserImage = (moralisAttributes, imageSize = 50) => {
    if (moralisAttributes) {
      if ("profileImageCID" in moralisAttributes && moralisAttributes.profileImageCID != null) {
        const profileImageUrl = `https://hodl4gold.mypinata.cloud/ipfs/${moralisAttributes.profileImageCID}`
        return <img className="profile-image view-nft-cover-profile" src={profileImageUrl} alt="" />
      } else {
        return (
          <UserIdenticon
            size={imageSize}
            walletAddress={moralisAttributes.walletAddress}
            customCss={{ width: "50px", height: "50px" }}
          />
        );
      }
    } else {
      return (
        <UserIdenticon
          size={imageSize}
          walletAddress={account}
          customCss={{ width: "50px", height: "50px" }}
        />
      );
    }
  };


  return (
    <div>
      <section className="container"></section>
      <span>
        <Outer> {coverImage} </Outer>
      </span>
      <section className='container d_coll no-top no-bottom'>
        <div className='row'>
          <div className="col-md-12">
            <div className="d_profile">
              <div className="profile_avatar">
                <div className="d_profile_img">
                  {getUserImage(profileData?.attributes, 100)}
                </div>

                <div className="profile_name">
                  {
                    isLoadingProfile ?
                      (<div className="spinner-grow spinner-grow-sm" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>)
                      :
                      (<h4>
                        {getUsername(profileData ? profileData.attributes : null)}
                        <div className="clearfix"></div>

                        <span id="wallet" className="profile_wallet">Created by {getUsername(profileData ? profileData.attributes : null)} </span>
                      </h4>)
                  }
                </div>
              </div>
            </div>
          </div>
        </div>



        {
          isAllowToEdit ?
            (
              <div className='row collection-edit-container'>
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <div className='dropdownSelect one'>
                    <Select
                      className='select1'
                      styles={customStyles}
                      menuContainerStyle={{ 'zIndex': 999 }}
                      value={
                        nftStatus.filter(option =>
                          option.value === selectedCollectionStatus)
                      }
                      defaultValue={nftStatus[0]}
                      onChange={handleCollectionStatusChange}
                      options={nftStatus} />
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 collection-update-btn-container">

                  {
                    isCollectionUpdating ?
                      (<div className="spinner-grow spinner-grow-sm" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>)
                      :
                      (<div className="list-nft-btn collection-update-btn" onClick={handleCollectionStatusUpdate}>
                        <span>Update Status</span>
                      </div>)
                  }

                </div>
              </div>
            )
            :
            (<div></div>)
        }




      </section>
      <section className='container no-top'>
        <div>
          {
            nftData && nftData.length > 0 ?
              (
                <div className='row'>
                  {
                    nftData.map((item, index) => (
                      <div key={index} className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <BuyNFTContainer data={item} objectId={item.itemId} />
                      </div>

                    ))
                  }
                </div>
              ) : (
                <div className='row'>
                  <div className='col-sm-12 col-md-12 col-lg-12'>
                    <div className='loading-container'>
                      Sorry no items available for sale
                    </div>
                  </div>
                </div>
              )
          }
        </div>
      </section>
    </div>
  )
}
export default ViewCollections;